'use client';
module.exports = require('../dist/components/Link/Link');
